<template>
  <div class="notifications card text-md" id="tpl_newTask_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon icon="fa-xmark"/>
      </i>
    </div>
    <div class="text-justify p-5">
      <div class="flex">
        <h3>
          <span id="tpl_newTask_popup_firstName">
          {{ notification.content.firstName }}
          </span>
          <span id="tpl_newTask_popup_header">
            {{ $t('NewTaskNotificationComponent.newTaskCreatedForYou') }}
          </span>
        </h3>
      </div>
      <div class="mt-2 text-md">
        <p>
          <span id="tpl_newTask_popup_text">
            {{ $t('NewTaskNotificationComponent.wantToCheckItOut') }}
          </span>
          <router-link :to="getLink" class="text-md font-semibold text-[var(--color-orange)]
            hover:text-[var(--color-fulvous)]" id="tpl_newTask_popup_link">
            {{ ' ' + $t('NewTaskNotificationComponent.clickHere') }}
          </router-link>
        </p>
      </div>
      <div class="text-[var(--color-disabled)] float-right text-xs">
        <span>
          {{ $t('NewTaskNotificationComponent.footlineOMIND') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['notification'],
  name: 'NewTaskNotificationComponent',
  computed: {
    getLink() {
      // TODO oim redirect to intro
      return `/questionnaire?id=${this.notification.assessment}`;
    },
  },
  methods: {
    deactivate() {
      this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
  },
};
</script>
